import { LoadableDocuments, LoadableTreeCategory } from "features";
import React, { useCallback, useState } from "react";
import { Breadcrumb } from "shared/ui/components";
import Grid from "@mui/material/Grid";
import { Split } from "@geoffcox/react-splitter";
import DehazeIcon from "@mui/icons-material/Dehaze";

export default function DocumentsPage() {
  const [TreeOpen, setTreeOpen] = useState(true);
  const onClickHidenTree = useCallback(() => setTreeOpen((prev) => !prev), []);

  return (
    <>
      <Grid container direction="row">
        <button
          style={{ border: "none", backgroundColor: "inherit" }}
          onClick={onClickHidenTree}
        >
          <DehazeIcon />
        </button>
        <Breadcrumb />
      </Grid>
      {TreeOpen && (
        <div style={{ height: "82vh" }}>
          <Split initialPrimarySize="15%">
            <LoadableTreeCategory />
            <LoadableDocuments />
          </Split>
        </div>
      )}
      {!TreeOpen && <LoadableDocuments />}
    </>
  );
}
